const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Params = {
  API_BASE_URL,
};

export default Params;
